"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToChildrenTypographyProps = exports.mapToTitleTypographyProps = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const DialogContent_1 = tslib_1.__importDefault(require("@mui/material/DialogContent"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const colors_1 = require("../colors");
const defaults = (props) => ({
    disableTitleTypography: false,
    titleTypographyProps: {},
    disableChildrenTypography: false,
    childrenTypographyProps: {},
    classes: {},
    ...props,
});
const mapToTitleTypographyProps = (props) => {
    const { titleTypographyProps } = defaults(props);
    return {
        variant: "subtitle1",
        color: "error",
        sx: { mb: 2 },
        ...titleTypographyProps,
    };
};
exports.mapToTitleTypographyProps = mapToTitleTypographyProps;
const mapToChildrenTypographyProps = ({ childrenTypographyProps, }) => ({
    variant: "body1",
    color: "error",
    ...childrenTypographyProps,
});
exports.mapToChildrenTypographyProps = mapToChildrenTypographyProps;
const isReactElement = (element) => react_1.default.isValidElement(element);
const DialogError = (props) => {
    const { title: titleProp, disableTitleTypography = false, children: childrenProp, disableChildrenTypography = false, ...rest } = props;
    let title = titleProp;
    if (title != null &&
        ((isReactElement(title) && title.type !== Typography_1.default) || typeof title === "string") &&
        !disableTitleTypography) {
        title = react_1.default.createElement(Typography_1.default, { ...(0, exports.mapToTitleTypographyProps)({ ...props }) }, title);
    }
    let children = childrenProp;
    if (children != null &&
        ((isReactElement(children) && children.type !== Typography_1.default) || typeof children === "string") &&
        !disableChildrenTypography) {
        children = react_1.default.createElement(Typography_1.default, { ...(0, exports.mapToChildrenTypographyProps)({ ...props }) }, children);
    }
    return (react_1.default.createElement(DialogContent_1.default, { sx: { backgroundColor: colors_1.black[100], mb: 2, py: 3, px: 2 }, ...rest },
        title,
        children));
};
exports.default = DialogError;
